<script setup lang="ts">
import Settings, { type ListDisplayMode } from "@/stores/Settings";
import SettingsOptionRow from "./SettingsOptionRow.vue";

const options: ListDisplayMode[] = ["grid", "list"];
</script>

<template>
  <SettingsOptionRow
    :label="$t('dashboard:settings.displayItems.title')"
    icon="bi-grid"
  >
    <el-button-group class="ml-4">
      <el-button
        v-for="option in options"
        :key="option"
        :type="Settings.displayMode === option ? 'primary' : 'default'"
        @click="Settings.setDisplayMode(option)"
        >{{ $t(`dashboard:settings.displayItems.option.${option}`) }}</el-button
      >
    </el-button-group>
  </SettingsOptionRow>
</template>
